import { render, staticRenderFns } from "./combined-purchases-report.vue?vue&type=template&id=5b536d90&scoped=true"
import script from "./combined-purchases-report.vue?vue&type=script&lang=js"
export * from "./combined-purchases-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b536d90",
  null
  
)

export default component.exports